<div class="skeleton" aria-busy="true" aria-label="Loading trend metrics">
  <ngx-skeleton-loader class="skeleton__chart" count="1" appearance="line" [theme]="chartTheme"></ngx-skeleton-loader>
  <div class="skeleton__tiles">
    <ngx-skeleton-loader
      class="skeleton__tile"
      *ngFor="let tile of tiles; trackBy: trackByIndex"
      count="1"
      appearance="line"
      [theme]="tileTheme"
    ></ngx-skeleton-loader>
  </div>
</div>
